export const AUTH_TOKEN = 'AUTH_TOKEN';
export const EMAIL = 'email';
export const DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER';
export const PRODUCT_TYPE = 'PRODUCT_TYPE';
export const LOGISTIC_KIND = 'LOGISTIC_KIND';
export const PC_ID = 'PC_ID';
export const IS_PRINTER_COMPUTER = 'IS_PRINTER_COMPUTER';
